import React from 'react'
import styled from 'styled-components'
import { fadeUp } from '../styles'

const Wrapper = styled.div`
    width: 100%;
    animation: ${fadeUp} 300ms linear;
    text-align: center;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    margin-bottom: 32px;
    h1 {
        font-weight: 600;
        font-size: 24px;
        line-height: 28px;
        margin: 0 0 4px 0;
    }

    p {
        margin: 0;
        font-size: 14px;
        opacity: 0.8;
    }
`

const Title = ({ title, subtitle }) => (
    <Wrapper>
        <h1>{title}</h1>
        <p>{subtitle}</p>
    </Wrapper>
)

export default Title